export default __webpack_public_path__ + "static/media/sch5.bd18714d.jpg";